import { SiteCreateState } from "@/Administration/Components/Sites/SiteCreate";
import { AdministrationHelper } from "@/Administration/Helpers/AdministrationHelper";
import { CheckboxControl } from "@/Common/Components/Inputs/CheckboxControl";
import { useTranslation } from "@/Common/CustomHooks/useTranslation";
import { SiteSpecialtyId } from "@/Common/Models/Sites/SiteSpecialtyId";

interface IOfferedSpecialtiesSubSectionProps {
    specialties: SiteSpecialtyId[];
    offeredSpecialtyIds: string[];
    mutateState: (mutation: (state: SiteCreateState) => void, then?: () => void) => void;
}

function OfferedSpecialtiesSubSection(props: IOfferedSpecialtiesSubSectionProps): JSX.Element {
    const { specialties, offeredSpecialtyIds, mutateState } = props;
    const { getText } = useTranslation();

    const onOfferedSpecialitySelectAll = (isSelected: boolean): void => {
        mutateState(s => {
            s.offeredSpecialtyIds = isSelected ? specialties.map(item => AdministrationHelper.getSpecialtyDictionaryOrLookupId(item)) : [];
        });
    };

    const onSpecialitySelectChange = (specialtyId: string, isSelected: boolean): void => {
        const specialtyIds = [...offeredSpecialtyIds];
        if (isSelected) {
            specialtyIds.push(specialtyId);
        }
        else {
            specialtyIds.splice(specialtyIds.indexOf(specialtyId), 1);
        }

        mutateState(s => {
            s.offeredSpecialtyIds = specialtyIds;
        });
    };

    return (
        <>
            <div className="view-subsection-header row">
                <div className="col-lg-4 col-md-2 col-sm-2 text-right">
                    <h4 className="view-subsection-title">{getText("ClinicInfo_OfferedSpecialtiesLabel")}</h4>
                </div>
            </div>

            <div className="view-subsection-body">
                <div className="row margin-md-bottom">
                    <div className="col-lg-4 col-md-2 col-sm-2 text-right" />
                    <div className="col-lg-5 col-md-6 col-sm-6 form-field-answer">
                        <label className="form-label">{getText("ClinicInfo_OfferedSpecialitiesPortalInfoLabel")}</label>
                    </div>
                </div>
                {specialties?.any() && (
                    <div className="row margin-md-bottom">
                        <div className="col-lg-4 col-md-2 col-sm-2 text-right" />
                        <div className="col-lg-5 col-md-6 col-sm-6 form-field-answer">
                            <CheckboxControl
                                checked={specialties.length === offeredSpecialtyIds.length}
                                label={getText("AllLabel")}
                                onChange={isSelected => onOfferedSpecialitySelectAll(isSelected)}
                            />
                        </div>
                    </div>
                )}
                {specialties?.map((siteSpecialtyId: SiteSpecialtyId, index: number) => {
                    const specialtyId = AdministrationHelper.getSpecialtyDictionaryOrLookupId(siteSpecialtyId);
                    const isSelected = offeredSpecialtyIds?.contains(specialtyId);
                    const label = AdministrationHelper.getSpecialityByCurrentLanguage(siteSpecialtyId);

                    return (
                        <div key={`specialty_${index}`} className="row margin-md-bottom">
                            <div className="col-lg-4 col-md-2 col-sm-2 text-right" />
                            <div className="col-lg-5 col-md-6 col-sm-6 form-field-answer">
                                <CheckboxControl
                                    checked={isSelected}
                                    label={label}
                                    onChange={isSelected => onSpecialitySelectChange(specialtyId, isSelected)}
                                    item={siteSpecialtyId}
                                />
                            </div>
                        </div>
                    );
                })}
            </div>
        </>
    );
}

export { IOfferedSpecialtiesSubSectionProps };
export default OfferedSpecialtiesSubSection;
